import type { LanguageCode } from '@coursera/cds-common';

type SortResult = 1 | -1 | 0;

const basicComparator = <K>(a: K, b: K): SortResult => {
  return a === b ? 0 : a > b ? 1 : -1;
};

export const i18nSort = <T, K extends keyof T>(
  rowA: T,
  rowB: T,
  columnId: K,
  locale?: LanguageCode
): SortResult => {
  const collator = new Intl.Collator(locale || 'en');
  return collator.compare(
    (rowA[columnId] as unknown) as string,
    (rowB[columnId] as unknown) as string
  ) as SortResult;
};

export const basicSort = <T, K extends keyof T>(
  rowA: T,
  rowB: T,
  columnId: K
): SortResult => {
  return basicComparator(rowA[columnId], rowB[columnId]);
};

export const datetimeSort = <T, K extends keyof T>(
  rowA: T,
  rowB: T,
  columnId: K
): SortResult => {
  const a = new Date((rowA[columnId] as unknown) as string | number);
  const b = new Date((rowB[columnId] as unknown) as string | number);
  return basicComparator(a.getTime(), b.getTime());
};
